import { ImagingUltrasoundConstants } from '../../../features/procedures/imagingUltrasound/store/imagingUltrasound.constants'

export const procedureFooterSchemas = [
  {
    inputKey: 'cardiac/SET_COMMENTS',
    isNumber: false,
    type: 'object',
    properties: {
      SET_COMMENTS: {
        type: 'string',
        pattern: '^([\x20-\x7F]){1,999}$',
      },
    },
    additionalProperties: false,
    required: ['SET_COMMENTS'],
    errorMessage: {
      properties: {
        SET_COMMENTS: 'Must be alphanumeric with max length of 1000',
      },
    },
  },
  {
    inputKey: 'airway/SET_COMMENTS',
    isNumber: false,
    type: 'object',
    properties: {
      SET_COMMENTS: {
        type: 'string',
        pattern: '^([\x20-\x7F]){1,999}$',
      },
    },
    additionalProperties: false,
    required: ['SET_COMMENTS'],
    errorMessage: {
      properties: {
        SET_COMMENTS: 'Must be alphanumeric with max length of 1000',
      },
    },
  },
  {
    inputKey: 'initiateIv/SET_COMMENTS',
    isNumber: false,
    type: 'object',
    properties: {
      SET_COMMENTS: {
        type: 'string',
        pattern: '^([\x20-\x7F]){1,999}$',
      },
    },
    additionalProperties: false,
    required: ['SET_COMMENTS'],
    errorMessage: {
      properties: {
        SET_COMMENTS: 'Must be alphanumeric with max length of 1000',
      },
    },
  },
  {
    inputKey: 'intubation/SET_COMMENTS',
    isNumber: false,
    type: 'object',
    properties: {
      SET_COMMENTS: {
        type: 'string',
        pattern: '^([\x20-\x7F]){1,999}$',
      },
    },
    additionalProperties: false,
    required: ['SET_COMMENTS'],
    errorMessage: {
      properties: {
        SET_COMMENTS: 'Must be alphanumeric with max length of 1000',
      },
    },
  },
  {
    inputKey: ImagingUltrasoundConstants.SET_COMMENTS,
    isNumber: false,
    type: 'object',
    properties: {
      SET_COMMENTS: {
        type: 'string',
        pattern: '^([\x20-\x7F]){1,999}$',
      },
    },
    additionalProperties: false,
    required: ['SET_COMMENTS'],
    errorMessage: {
      properties: {
        SET_COMMENTS: 'Must be alphanumeric with max length of 1000',
      },
    },
  },
]
